<template>
  <div class="fc-slider">
    <div class="ui-slider-handle fc-cursor">
      <div class="fc-value-0"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'fc-slider',
  props: ['value', 'ui'],
  mounted: function () {
    const vm = this
    $(this.$el).slider(Object.assign( // merge avec options jquery ui
      {
        range: false,
        create: function (event, ui) {
          $(this).find('.fc-value-0').text(vm.value + vm.ui.fcValueSuffix)
          // FC NON attendre options sinon pb placement initial curseur
          // si borne différente de 0
          // $(this).slider('value',vm.value);
        },
        slide: function (event, ui) {
          $(this).find('.fc-value-0').text(ui.value + vm.ui.fcValueSuffix)
          this.value = ui.value
          vm.$emit('input', this.value)
        },
      }
      , this.ui.jqoptions))
    // FC place le curseur à sa position initiale une fois les options fixées
    $(this.$el).slider('value', vm.value)
    // drag on mobile
    // $('.ui-slider-handle').draggable();
  },
}
</script>

<style lang="scss">
.fc-slider {
  margin: 60px 26px;

  .error &.ui-widget.ui-widget-content {
    box-shadow: inset 0 0 0 1px $red;
  }
}
</style>
